export default __webpack_public_path__ + "images/credit-card-logos/amex.png";